var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666672 6.85661C0.666672 6.41458 0.842266 5.99065 1.15483 5.67809L5.68246 1.15047C6.08466 0.748264 6.76269 0.858294 7.01707 1.36704L7.06473 1.46236C7.22514 1.78318 7.16226 2.17066 6.90863 2.42429L3.30893 6.02399C3.25643 6.07649 3.29361 6.16625 3.36786 6.16625H16.5C16.9602 6.16625 17.3333 6.53935 17.3333 6.99958C17.3333 7.45982 16.9602 7.83292 16.5 7.83292H3.36786C3.29361 7.83292 3.25643 7.92268 3.30893 7.97517L6.90863 11.5749C7.16226 11.8285 7.22514 12.216 7.06473 12.5368L7.01707 12.6321C6.76269 13.1409 6.08466 13.2509 5.68246 12.8487L1.15483 8.32107C0.842266 8.00851 0.666672 7.58459 0.666672 7.14256V6.85661Z",
    fill: "#313131"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.666672 6.85661C0.666672 6.41458 0.842266 5.99065 1.15483 5.67809L5.68246 1.15047C6.08466 0.748264 6.76269 0.858294 7.01707 1.36704L7.06473 1.46236C7.22514 1.78318 7.16226 2.17066 6.90863 2.42429L3.30893 6.02399C3.25643 6.07649 3.29361 6.16625 3.36786 6.16625H16.5C16.9602 6.16625 17.3333 6.53935 17.3333 6.99958C17.3333 7.45982 16.9602 7.83292 16.5 7.83292H3.36786C3.29361 7.83292 3.25643 7.92268 3.30893 7.97517L6.90863 11.5749C7.16226 11.8285 7.22514 12.216 7.06473 12.5368L7.01707 12.6321C6.76269 13.1409 6.08466 13.2509 5.68246 12.8487L1.15483 8.32107C0.842266 8.00851 0.666672 7.58459 0.666672 7.14256V6.85661Z",
    fill: "#313131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/BackArrow.df9c4c7a12581961504e9b71116d7f86.svg";
export { ForwardRef as ReactComponent };